document.addEventListener('DOMContentLoaded', function () {
  function sortProductsByStock(container) {
    var products = Array.from(container.querySelectorAll('.product'));
    if (products.length === 0) return;

    var inStock = [];
    var outStock = [];

    products.forEach(function (product) {
      var isSoldOut = product.querySelector('.sold-out-badge') !== null;
      if (isSoldOut) {
        outStock.push(product);
      } else {
        inStock.push(product);
      }
    });

    // Agar sab in-stock hain ya sab out-stock — kuch karne ki zaroorat nahi
    if (outStock.length === 0 || inStock.length === 0) return;

    // Slider check karo
    var isSlider = container.classList.contains('products-carousel');

    if (isSlider && typeof jQuery !== 'undefined') {
      var $container = jQuery(container);
      
      // Pehle slider destroy karo
      if ($container.hasClass('slick-initialized')) {
        $container.slick('unslick');
      }

      // Products reorder karo
      inStock.forEach(function (p) { container.appendChild(p); });
      outStock.forEach(function (p) { container.appendChild(p); });

      // Ella theme ka apna slider reinit trigger karo
      setTimeout(function () {
        jQuery(document).trigger('halo:reinit-slider', [$container]);
        // Ya theme ka default event
        $container.trigger('reinit');
      }, 100);

    } else {
      // Grid ya scroll layout — seedha reorder karo
      inStock.forEach(function (p) { container.appendChild(p); });
      outStock.forEach(function (p) { container.appendChild(p); });
    }
  }

  function initSort() {
   var containers = document.querySelectorAll(
  '.products-grid, .products-flex'  // .products-carousel hata diya
)
    containers.forEach(function (container) {
      sortProductsByStock(container);
    });
  }

  setTimeout(initSort, 800);
  setTimeout(initSort, 2000);

  var observer = new MutationObserver(function () {
    setTimeout(initSort, 400);
  });

  observer.observe(document.body, { childList: true, subtree: true });
});